import {AxiosPromise} from 'axios';

import {ActionType} from '@typescript/common/actionTypes';
import {CUSTOMER} from 'constants/actions';
import {ENDPOINTS} from 'constants/endpoints';
import {instanceGusaBackend} from 'libs/api';

/**
 * Get current status of user (logged or not)
 * And also returns data about the user, when there is brontoId and subscriberId
 *
 * @param {string} brontoId - Customer bronto id
 * @param {string} subscriberId - Customer magento id
 * @returns {ActionType<AxiosPromise>} Current status of user
 */
export function getCustomerData(brontoId = '', subscriberId = ''): ActionType<AxiosPromise> {
    return {
        type: CUSTOMER.GET_CUSTOMER_DATA,
        payload: instanceGusaBackend({
            method: 'get',
            url: ENDPOINTS.CUSTOMER_CURRENT,
            params: {
                contact_eid: brontoId,
                magento_subsciber_id: subscriberId,
            },
        }),
    };
}

/**
 * Fetches a customer's last saved prescription.
 * @returns {ActionType<AxiosPromise>} Action
 */
export function fetchPrescription(): ActionType<AxiosPromise> {
    return {
        type: CUSTOMER.FETCH_PRESCRIPTION,
        payload: instanceGusaBackend.get(ENDPOINTS.CUSTOMER_FETCH_PRESCRIPTION),
    };
}
